module.exports = __webpack_public_path__ + "img/icon-ydwl.f43d3127.png";